@if (isLoading()) {
  <main class="loading-container e-color-background-1">
    <div class="e-w-100">
      <h1 class="e-title-lg e-text-center e-mb-16">Laster inn...</h1>
      <elvia-progress-linear size="large" isIndeterminate />
    </div>
  </main>
}

<main [class.e-sr-only]="isLoading()" [inert]="isLoading()">
  <h1 class="e-sr-only">Elvia Strømbruddskart</h1>
  <app-map />
  <app-search class="search-position" />
  <app-info-container class="info-position" />
  <aside class="controls-position e-flex e-flex-direction-column e-gap-16">
    <app-zoom-buttons />
    <app-locate-user-button />
  </aside>
  <app-legends class="legends-position" />
</main>

<elvia-toast />
<elvia-outline />

@let _maintenance = globalBannerService.activeMaintenance();
@if (_maintenance) {
  <app-global-banner [maintenance]="_maintenance" (dismiss)="globalBannerService.dismiss()" />
}
